import React from 'react';
import { Grid, TextField, FormGroup, MenuItem } from '@mui/material';
import { RigsFieldSet, RobotsFieldSet, TeamFieldSet } from '@rogoag/airtable/crm';
import { LocalAtRecord } from '../../db';

interface CreateShiftFormFieldsProps {
  schedDate: string;
  robot: string;
  operator: string;
  rig: string;
  allRobots: LocalAtRecord<RobotsFieldSet>[];
  allOperators: LocalAtRecord<TeamFieldSet>[];
  allRigs: LocalAtRecord<RigsFieldSet>[];
  onSchedDateChange: (value: string) => void;
  onRobotChange: (value: string) => void;
  onOperatorChange: (value: string) => void;
  onRigChange: (value: string) => void;
}

const fieldStyle = { marginLeft: '2.5%', marginRight: '2.5%', marginTop: 8, marginBottom: 8, width: '45%' };

const CreateShiftFormFields: React.FC<CreateShiftFormFieldsProps> = ({
  schedDate,
  robot,
  operator,
  rig,
  allRobots,
  allOperators,
  allRigs,
  onSchedDateChange,
  onRobotChange,
  onOperatorChange,
  onRigChange,
}) => (
  <Grid container size={12}>
    <FormGroup row style={{ width: '100%' }}>
      {/* TextField (not raw Select) handles the v7 outlined notched-label
          wiring internally — the InputLabel position and the OutlinedInput
          notch are kept in sync without needing extra slot props. */}
      <TextField
        label="Sched Date"
        type="date"
        style={fieldStyle}
        value={schedDate}
        onChange={(e) => onSchedDateChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />

      <TextField
        select
        label="Robot"
        style={fieldStyle}
        value={robot}
        onChange={(event) => onRobotChange(event.target.value as string)}
        InputLabelProps={{ shrink: true }}
        SelectProps={{ displayEmpty: true }}
      >
        {allRobots.map((r) => (
          <MenuItem key={r.id} value={r.id}>
            {r.get('Name')}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label="Operator"
        style={fieldStyle}
        value={operator}
        onChange={(event) => onOperatorChange(event.target.value as string)}
        InputLabelProps={{ shrink: true }}
        SelectProps={{ displayEmpty: true }}
      >
        {allOperators.map((op) => (
          <MenuItem key={op.id} value={op.id}>
            {op.get('Name')}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label="RIG"
        style={fieldStyle}
        value={rig}
        onChange={(event) => onRigChange(event.target.value as string)}
        InputLabelProps={{ shrink: true }}
        SelectProps={{ displayEmpty: true }}
      >
        {allRigs.map((rg) => (
          <MenuItem key={rg.id} value={rg.id}>
            {rg.get('Name')}
          </MenuItem>
        ))}
      </TextField>
    </FormGroup>
  </Grid>
);

export default CreateShiftFormFields;
